import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { brand6 } from "@/brand/contentF6";

const SITE = brand6.legalName;
const DEFAULT_TITLE = `${SITE} — ${brand6.category}`;
const DEFAULT_DESC =
  "Steady counsel for high-stakes people, leadership, and workplace moments. Confidential advisory for mission-driven, values-led, and public-sector-adjacent organizations.";

function upsertMeta(key, content, isProperty = false) {
  const attr = isProperty ? "property" : "name";
  let el = document.head.querySelector(`meta[${attr}="${key}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
}

function upsertCanonical(href) {
  let el = document.head.querySelector('link[rel="canonical"]');
  if (!el) {
    el = document.createElement("link");
    el.setAttribute("rel", "canonical");
    document.head.appendChild(el);
  }
  el.setAttribute("href", href);
}

function clamp(text, max = 160) {
  const t = (text || "").replace(/\s+/g, " ").trim();
  return t.length > max ? `${t.slice(0, max - 1).replace(/\s+\S*$/, "")}…` : t;
}

/**
 * usePageMeta — per-route document title, description, canonical, and
 * Open Graph / Twitter text. Title pattern: "Page · Faith 1st Consulting".
 */
export function usePageMeta({ title, description, type = "website", noindex = false } = {}) {
  const { pathname } = useLocation();

  useEffect(() => {
    const fullTitle = title ? `${title} · ${SITE}` : DEFAULT_TITLE;
    const desc = clamp(description || DEFAULT_DESC);
    const url = `${brand6.siteUrl}${pathname === "/" ? "/" : pathname}`;

    document.title = fullTitle;
    upsertMeta("description", desc);
    upsertMeta("robots", noindex ? "noindex, nofollow" : "index, follow");
    upsertMeta("og:title", fullTitle, true);
    upsertMeta("og:description", desc, true);
    upsertMeta("og:url", url, true);
    upsertMeta("og:type", type, true);
    upsertMeta("twitter:title", fullTitle);
    upsertMeta("twitter:description", desc);
    upsertCanonical(url);
  }, [title, description, type, noindex, pathname]);
}
